<div class="table-container" [formGroup]="filterForm">
  <span class="table-heading" *ngIf="heading">{{ heading }}</span>
  <div class="table-div">
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)">
      <ng-container *ngFor="let column of columns" [matColumnDef]="column.columnDef">
        <ng-container>
          <th
            mat-header-cell
            *matHeaderCellDef
            [mat-sort-header]="column.sortable ? column.columnDef : null"
            [ngClass]="{
              'right-align': column?.align === 'right',
              'left-align': column?.align === 'left',
              'centre-align': column?.align !== 'right' && column?.align !== 'left',
            }"
            [disabled]="!column.sortable">
            <app-table-header-cell [filterForm]="filterForm" [column]="column"></app-table-header-cell>
          </th>
        </ng-container>
        <td
          mat-cell
          *matCellDef="let element"
          (click)="handleCellClickForViewDetail(column.columnDef, element)"
          [ngClass]="{
              'right-align': column?.align === 'right',
              'left-align': column?.align === 'left',
              'centre-align': column?.align !== 'right' && column?.align !== 'left',
              'v-align-top': column?.verticalAlign === 'top'
            }"
          [style.paddingRight.px]="10"
          [style.paddingLeft.px]="10">
          <app-table-cell [column]="column" [element]="element" (cellClick)="handleCellClick($event)"></app-table-cell>
        </td>
      </ng-container>
      <tr class="table-tr" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        class="table-tr"
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [class.selected]="isRowClickable && selectedRow === row"
        [class.selectable]="isRowClickable"
        (click)="stopPropagation($event)"></tr>
    </table>
  </div>

  <div *ngIf="columns.length === 0">No columns to display.</div>

  <div class="paginator-container">
    <mat-paginator
      [length]="tableData?.totalElements"
      [pageSize]="tableData?.pageSize"
      [pageIndex]="tableData?.pageNumber"
      (page)="onPageChange($event)"
      [pageSizeOptions]="[20, 50, 100]"
      showFirstLastButtons="false"></mat-paginator>
  </div>
</div>
